import { lt } from '@mews/framework';
import { Stack, Typography } from '@optimus-web/core';
import { WithResourceId } from '@mews-commander/types';
import { Account } from '@mews-commander/data-access';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedDateFromUtc, SpacedDash } from '@mews-commander/ui';
import { ResourceCategoryName, ResourceName } from '../../../../../common';
import { AccountName } from '../../../../../../../../components';

export interface ReservationInfoHeaderProps extends WithResourceId {
    ownerAccount: Account;
    startDate: string;
    endDate: string;
}

interface InfoRowProps {
    label: React.ReactNode;
    children: React.ReactNode;
}

const InfoRow = ({ label, children }: InfoRowProps) => (
    <Stack distribution="space-between">
        <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
            {label}
        </Typography>
        {children}
    </Stack>
);

export const ReservationInfoHeader = ({ resourceId, ownerAccount, startDate, endDate }: ReservationInfoHeaderProps) => (
    <Stack vertical spacing="50">
        <InfoRow label={lt('Customer')}>
            <AccountName account={ownerAccount} />
        </InfoRow>
        <InfoRow label={lt('Space')}>
            <ResourceName resourceId={resourceId} />
            {UnicodeEntity.Space}
            <ResourceCategoryName resourceId={resourceId} />
        </InfoRow>
        <InfoRow label={lt('Date')}>
            <Stack>
                <LocalizedDateFromUtc utcString={startDate} />
                {SpacedDash}
                <LocalizedDateFromUtc utcString={endDate} />
            </Stack>
        </InfoRow>
    </Stack>
);
